import React from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import {
  Card,
  CardTitle,
  Typography
} from '@one-thd/sui-atomic-components';
import HowItWorksDrawer from './HowItWorksDrawer';
import { useIsMobile } from './ProjectLocation/helpers';

const ExperienceTitle = () => {
  const experienceTitle = useConfigService('experience-title');
  const isMobile = useIsMobile();

  return (
    <Card style={{ marginBottom: '10px', border: 'none' }}>
      <CardTitle
        header={(
          <Typography variant="h1" weight="bold">
            {experienceTitle}
          </Typography>
        )}
        action={<HowItWorksDrawer />}
        actionPosition={isMobile ? 'start' : 'end'}
      />
    </Card>
  );
};

export { ExperienceTitle };
